import enviro from 'enviro';
const QA_WORKSHOP_IDS = [
// Get Started with HubSpot
2147503652,
// Sales Hub Essentials x 2
2147499648, 2147500649,
// Marketing Hub Essentials x 2
2147497689, 2147497691,
// Service Hub Essentials x 2
2147502655, 2147502656,
// Office hours
2147503653];

// While empty, `NextStepSection` skips its query and renders nothing on prod.
const PROD_WORKSHOP_IDS = [
// Get Started with HubSpot
2001,
// Sales Hub Essentials x 2
// Build pipeline with Sales Hub
// Close deals with Sales Hub
2003, 2004,
// Marketing Hub Essentials x 2
// Generate leads with Marketing Hub
// Automate marketing with Marketing Hub
2005, 2006,
// Service Hub Essentials x 2
// Scale support with Service Hub
// Drive retention with Service Hub
2007, 2008,
// Office hours
2002];
export const getOrderedNextStepEventIds = () => enviro.isQa() ? QA_WORKSHOP_IDS : PROD_WORKSHOP_IDS;
export const orderEventsByWorkshopIds = events => {
  const orderedIds = getOrderedNextStepEventIds();
  const eventsById = new Map(events.map(event => [event.id, event]));
  const orderedIdSet = new Set(orderedIds);
  const orderedEvents = orderedIds.map(id => eventsById.get(id)).filter(event => event !== undefined);
  const remainingEvents = events.filter(event => !orderedIdSet.has(event.id));
  return [...orderedEvents, ...remainingEvents];
};